"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var projectManageApi = _interopRequireWildcard(require("@/api/projectManageApi"));
var fudouActiveApi = _interopRequireWildcard(require("@/api/fudouActiveApi"));
var _ProjectDetail = _interopRequireDefault(require("./components/ProjectDetail.vue"));
var _CardDetail = _interopRequireDefault(require("./components/CardDetail.vue"));
var _vueCountTo = _interopRequireDefault(require("vue-count-to"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'welfare-project',
  components: {
    ProjectDetail: _ProjectDetail.default,
    CardDetail: _CardDetail.default,
    CountTo: _vueCountTo.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        projectName: '',
        projectType: '',
        projectStatus: '',
        cardId: '',
        customerId: '',
        miniappId: '',
        remark: '',
        startDate: '',
        endDate: '',
        page: 1,
        limit: 20,
        customerName: '',
        status: '',
        relativeId: ''
      },
      dateRange: [],
      tableData: [],
      total: 0,
      totalBeans: 0,
      availableBeans: 0,
      totalCards: 0,
      statistics: {
        projectNum: 0,
        projectTotalAmount: 0,
        projectBalanceAmount: 0,
        projectCardNum: 0
      },
      loading: false,
      projectTypeOptions: [],
      projectStatusOptions: [],
      cardOptions: [],
      customerOptions: [],
      miniappOptions: [],
      detailVisible: false,
      projectDetail: {},
      cardDetailVisible: false,
      projectId: null,
      isFilterCollapsed: true
    };
  },
  created: function created() {
    this.handlerGetListData();
    // Check if there's a customer ID in the route query
    if (this.$route.query.customerId) {
      this.listPram.customerId = this.$route.query.customerId;
      this.listPram.customerName = this.$route.query.customerName || '';
    }
  },
  mounted: function mounted() {
    this.handlerGetListData();
    // 移除初始化时自动获取所有选项，改为点击时再获取
    // this.fetchOptions();

    // Add keyboard shortcuts
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy: function beforeDestroy() {
    // Remove event listeners when component is destroyed
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    // 原有的选项批量加载方法，改为点击时按需加载
    fetchOptions: function fetchOptions() {
      var _this = this;
      // 获取客户选项
      this.getCustomerList();

      // 获取卡片选项
      fudouActiveApi.selectCard('').then(function (res) {
        _this.cardOptions = res.map(function (item) {
          return {
            value: item.id,
            label: item.card_name
          };
        });
      }).catch(function (err) {
        _this.$message.error('获取卡片列表失败');
      });

      // 获取小程序选项
      projectManageApi.getMiniappList().then(function (res) {
        _this.miniappOptions = res.map(function (item) {
          return {
            value: item.id,
            label: item.appName
          };
        });
      }).catch(function (err) {
        _this.$message.error('获取小程序列表失败');
      });
    },
    // 新增的各类选项单独加载方法 
    loadCardOptions: function loadCardOptions() {
      var _this2 = this;
      if (this.cardOptions && this.cardOptions.length > 0) {
        return; // 如果已经加载过，就不重复加载
      }
      this.loading = true;
      fudouActiveApi.selectCard('').then(function (res) {
        _this2.cardOptions = res.map(function (item) {
          return {
            value: item.id,
            label: item.card_name
          };
        });
        _this2.loading = false;
      }).catch(function (err) {
        _this2.$message.error('获取卡片列表失败');
        _this2.loading = false;
      });
    },
    loadCustomerOptions: function loadCustomerOptions() {
      if (this.customerOptions && this.customerOptions.length > 0) {
        return; // 如果已经加载过，就不重复加载
      }
      this.loading = true;
      this.getCustomerList();
    },
    loadMiniappOptions: function loadMiniappOptions() {
      var _this3 = this;
      if (this.miniappOptions && this.miniappOptions.length > 0) {
        return; // 如果已经加载过，就不重复加载
      }
      this.loading = true;
      projectManageApi.getMiniappList().then(function (res) {
        _this3.miniappOptions = res.map(function (item) {
          return {
            value: item.id,
            label: item.appName
          };
        });
        _this3.loading = false;
      }).catch(function (err) {
        _this3.$message.error('获取小程序列表失败');
        _this3.loading = false;
      });
    },
    loadProjectTypeOptions: function loadProjectTypeOptions() {
      var _this4 = this;
      if (this.projectTypeOptions && this.projectTypeOptions.length > 0) {
        return; // 如果已经加载过，就不重复加载
      }
      // 项目类型和状态是在获取列表数据时一起返回的，所有这里调用获取项目列表
      this.loading = true;
      var params = {
        page: 1,
        limit: 1 // 只需要获取选项数据，所以limit设为最小
      };
      projectManageApi.getFudouProjectList(params).then(function (res) {
        // 设置项目类型选项
        if (res.typeSelect && res.typeSelect.length > 0) {
          _this4.projectTypeOptions = res.typeSelect.map(function (item) {
            return {
              value: item.key,
              label: item.value
            };
          });
        }
        _this4.loading = false;
      }).catch(function (err) {
        _this4.$message.error('获取项目类型失败');
        _this4.loading = false;
      });
    },
    loadProjectStatusOptions: function loadProjectStatusOptions() {
      var _this5 = this;
      if (this.projectStatusOptions && this.projectStatusOptions.length > 0) {
        return; // 如果已经加载过，就不重复加载
      }
      // 项目类型和状态是在获取列表数据时一起返回的，所有这里调用获取项目列表
      this.loading = true;
      var params = {
        page: 1,
        limit: 1 // 只需要获取选项数据，所以limit设为最小
      };
      projectManageApi.getFudouProjectList(params).then(function (res) {
        // 设置项目状态选项
        if (res.statusSelect && res.statusSelect.length > 0) {
          // 从API获取状态列表
          _this5.projectStatusOptions = res.statusSelect.map(function (status) {
            var cleanStatus = status.replace(/\.+$/, '');
            return {
              value: cleanStatus,
              label: cleanStatus
            };
          });
        }
        _this5.loading = false;
      }).catch(function (err) {
        _this5.$message.error('获取项目状态失败');
        _this5.loading = false;
      });
    },
    handerSearch: function handerSearch() {
      console.log('listPram', this.listPram.relativeId);
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    resetSearch: function resetSearch() {
      this.listPram = {
        projectName: '',
        projectType: '',
        projectStatus: '',
        cardId: '',
        customerId: '',
        miniappId: '',
        remark: '',
        startDate: '',
        endDate: '',
        page: 1,
        limit: 20,
        customerName: '',
        status: '',
        relativeId: ''
      };
      this.dateRange = [];
      this.handlerGetListData();
    },
    handleDateChange: function handleDateChange(val) {
      if (val) {
        this.listPram.startDate = val[0];
        this.listPram.endDate = val[1];
      } else {
        this.listPram.startDate = '';
        this.listPram.endDate = '';
      }
    },
    handlerGetListData: function () {
      var _handlerGetListData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params, res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              // 调用项目列表API
              params = {
                page: this.listPram.page,
                limit: this.listPram.limit,
                projectName: this.listPram.projectName || undefined,
                projectType: this.listPram.projectType || undefined,
                projectStatus: this.listPram.projectStatus || undefined,
                cardId: this.listPram.cardId || undefined,
                customerId: this.listPram.customerId || undefined,
                appId: this.listPram.miniappId || undefined,
                innerRemark: this.listPram.remark || undefined,
                startTime: this.listPram.startDate || undefined,
                endTime: this.listPram.endDate || undefined,
                relativeId: this.listPram.relativeId || undefined
              };
              _context.n = 2;
              return projectManageApi.getFudouProjectList(params);
            case 2:
              res = _context.v;
              // 设置项目类型选项
              if (res.typeSelect && res.typeSelect.length > 0) {
                this.projectTypeOptions = res.typeSelect.map(function (item) {
                  return {
                    value: item.key,
                    label: item.value
                  };
                });
              }

              // 设置项目状态选项
              if (res.statusSelect && res.statusSelect.length > 0) {
                // 从API获取状态列表
                this.projectStatusOptions = res.statusSelect.map(function (status) {
                  var cleanStatus = status.replace(/\.+$/, '');
                  return {
                    value: cleanStatus,
                    label: cleanStatus
                  };
                });
              }

              // 保存统计信息
              if (res.statistics) {
                this.statistics = res.statistics;
              }

              // 处理列表数据
              if (res.page) {
                this.tableData = res.page.list.map(function (item) {
                  // 处理有效期
                  var startDate = '-';
                  var endDate = '-';
                  if (item.validTime && item.validTime !== '-' && item.validTime.includes('-')) {
                    var timeArr = item.validTime.split('-');
                    startDate = timeArr[0].trim();
                    endDate = timeArr[1].trim();
                  }

                  // 处理项目状态，移除所有尾部的点
                  var cleanStatus = item.projectStatus ? item.projectStatus.replace(/\.+$/, '') : '';

                  // 创建表格行数据对象
                  return {
                    id: item.id,
                    projectName: item.projectName || '',
                    projectType: item.projectType || '',
                    relativeId: item.relativeId || '',
                    relatedNumber: item.relativeId ? "FD".concat(String(item.relativeId).padStart(6, '0')) : '-',
                    // 使用relativeId生成关联编号
                    cardName: item.cardName || '',
                    status: cleanStatus,
                    remark: item.innerRemark || '',
                    budget: parseFloat(item.totalAmount) || 0,
                    availableAmount: item.balanceAmount !== null ? parseFloat(item.balanceAmount) || 0 : 0,
                    cardCount: item.cardNum || 0,
                    miniappName: item.appName || '',
                    customerName: item.customerName || '',
                    issueTime: item.grantTime || '-',
                    startDate: startDate,
                    endDate: endDate,
                    createTime: item.projectTime || '-',
                    validTime: item.validTime && item.validTime !== '-' ? item.validTime : '-'
                  };
                });
                this.total = res.page.total || 0;

                // 计算统计信息（如果API没有返回statistics）
                if (!res.statistics) {
                  this.totalBeans = this.tableData.reduce(function (sum, item) {
                    return sum + (parseFloat(item.budget) || 0);
                  }, 0);
                  this.availableBeans = this.tableData.reduce(function (sum, item) {
                    return sum + (parseFloat(item.availableAmount) || 0);
                  }, 0);
                  this.totalCards = this.tableData.reduce(function (sum, item) {
                    return sum + (item.cardCount || 0);
                  }, 0);
                }
              } else {
                this.tableData = [];
                this.total = 0;
                this.totalBeans = 0;
                this.availableBeans = 0;
                this.totalCards = 0;
                this.statistics = {
                  projectNum: 0,
                  projectTotalAmount: 0,
                  projectBalanceAmount: 0,
                  projectCardNum: 0
                };
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.$message.error('获取项目列表失败');
              this.tableData = [];
              this.total = 0;
              this.totalBeans = 0;
              this.availableBeans = 0;
              this.totalCards = 0;
              this.statistics = {
                projectNum: 0,
                projectTotalAmount: 0,
                projectBalanceAmount: 0,
                projectCardNum: 0
              };
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function handlerGetListData() {
        return _handlerGetListData.apply(this, arguments);
      }
      return handlerGetListData;
    }(),
    handleDetail: function handleDetail(row) {
      this.$refs.projectDetailRef.openDetail(row.id, row);
    },
    handleCardDetail: function handleCardDetail(row) {
      // 跳转到卡片明细页面
      this.$router.push({
        path: '/welfare/cardDetail',
        query: {
          projectId: row.id
        }
      });
    },
    handleExport: function handleExport() {
      var _this6 = this;
      this.loading = true;
      // 构建导出参数，与查询参数保持一致
      var params = {
        projectName: this.listPram.projectName || undefined,
        projectType: this.listPram.projectType || undefined,
        projectStatus: this.listPram.projectStatus || undefined,
        cardId: this.listPram.cardId || undefined,
        customerId: this.listPram.customerId || undefined,
        appId: this.listPram.miniappId || undefined,
        innerRemark: this.listPram.remark || undefined,
        startTime: this.listPram.startDate || undefined,
        endTime: this.listPram.endDate || undefined
      };

      // 调用导出接口
      projectManageApi.exportFudouProjectList(params).then(function (res) {
        try {
          // 获取文件下载URL
          var downloadUrl = res.fileName;

          // 创建下载链接并点击
          var link = document.createElement('a');
          link.style.display = 'none';
          link.href = downloadUrl;

          // 从URL中提取文件名
          var fileName = downloadUrl.substring(downloadUrl.lastIndexOf('/') + 1);

          // 直接打开链接，不使用download属性，避免跨域问题
          link.setAttribute('target', '_blank');
          document.body.appendChild(link);
          link.click();
          setTimeout(function () {
            document.body.removeChild(link);
          }, 100);
          _this6.$message.success('导出成功，请在新窗口中下载文件');
        } catch (err) {
          _this6.$message.error('下载文件失败: ' + err.message);
        }
      }).catch(function (err) {
        _this6.$message.error('导出失败: ' + (err.message || '未知错误'));
      }).finally(function () {
        _this6.loading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    },
    getProjectTypeName: function getProjectTypeName(type) {
      var found = this.projectTypeOptions.find(function (item) {
        return item.value === type;
      });
      return found ? found.label : type;
    },
    getStatusType: function getStatusType(status) {
      // 项目状态映射到标签类型
      if (!status) return 'info';

      // 处理包含特定文本的状态
      if (status.includes('已生成订单')) {
        return 'primary';
      }
      var statusTypeMap = {
        '已删除': 'danger',
        '卡密生成中': 'info',
        '作废': 'danger',
        '已下单': 'primary',
        '已确认': 'warning',
        '已生成订单': 'primary',
        '待发放': 'warning',
        '已发放': 'success'
      };
      return statusTypeMap[status.replace(/\.+$/, '')] || 'info';
    },
    getStatusName: function getStatusName(status) {
      // 先检查是否为空值
      if (!status) return '';

      // 对特定状态进行检查和处理
      if (status.includes('已生成订单')) {
        return '已生成订单';
      }

      // 移除所有状态中的多余点
      return status.replace(/\.+$/, '');
    },
    formatMoney: function formatMoney(value) {
      if (!value && value !== 0) return '¥0';
      return '¥' + value.toLocaleString();
    },
    formatDate: function formatDate(date) {
      if (!date) return '';
      if (typeof date === 'string') {
        return date;
      }
      if (date instanceof Date) {
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        var hours = String(date.getHours()).padStart(2, '0');
        var minutes = String(date.getMinutes()).padStart(2, '0');
        var seconds = String(date.getSeconds()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
      }
      return '';
    },
    // Add keyboard shortcut handler
    handleKeyDown: function handleKeyDown(e) {
      // Only handle if no modals are open
      if (document.querySelector('.el-dialog__wrapper') || document.querySelector('.el-drawer__open') || document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        return;
      }

      // Handle different key combinations
      if (e.key === 'F5' || e.ctrlKey && e.key === 'r') {
        // Prevent browser reload
        e.preventDefault();
        // Refresh data
        this.handlerGetListData();
      } else if (e.ctrlKey && e.key === 'f') {
        // Prevent browser search
        e.preventDefault();
        // Focus on first input field
        var firstInput = document.querySelector('.box-card input');
        if (firstInput) firstInput.focus();
      } else if (e.key === 'Escape') {
        // Reset search
        this.resetSearch();
      }
    },
    // Add refresh data method
    refreshData: function refreshData() {
      this.handlerGetListData();
    },
    // 获取客户列表
    getCustomerList: function getCustomerList() {
      var _this7 = this;
      // 调用API获取客户列表
      projectManageApi.getCustomerList({
        page: 1,
        limit: 100
      }).then(function (res) {
        _this7.customerOptions = res.map(function (item) {
          return {
            value: item.id,
            label: item.name
          };
        });
      }).catch(function (err) {
        _this7.$message.error('获取客户列表失败');
      });
    }
  }
};